var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex field align-center justify-between push-top-xs"},[_c('label',{staticClass:"label is-marginless"},[_vm._v("Clear state")]),_c('button',{staticClass:"button is-small",on:{"click":_vm.clearState}},[_vm._v("Clear")])])}
var staticRenderFns = []

export { render, staticRenderFns }